import { Assignee, EachAssigneesRes } from './Assignees';
import { AuthUserI } from './AuthUser';
import { TicketDataFromMainPage } from './Ticket';
import { history } from '../helpers';
import { assignUnassignActions } from '../actions';
import { Statuses } from './Statuses';
import { HistoryHelper } from 'store/helpers/HistoryHelper';
declare type ButtonsInfo = EachButtonInfo[];
interface EachButtonInfo {
  label: string;
  onClick?: Function;
  autoFocus?: boolean;
}

class MainPageAlert {
  formattedTicket: TicketDataFromMainPage | null;
  user: AuthUserI;
  dispatch;
  fromCE: boolean;
  CEInbox: string | null;
  ticketError?: string | null;
  constructor(
    formattedTicket: TicketDataFromMainPage | null,
    user: AuthUserI,
    dispatch,
    fromCE: boolean,
    CEInbox: string | null,
    ticketError?: string | null,
  ) {
    this.formattedTicket = formattedTicket;
    this.user = user;
    this.dispatch = dispatch;
    this.fromCE = fromCE;
    this.CEInbox = CEInbox;
    this.ticketError = ticketError;
  }
  isNonSi(): boolean {
    return this.formattedTicket?.ticket?.si === false;
  }
  hasAssignee(): boolean {
    return this.formattedTicket?.ticket?.assignee ? true : false;
  }
  isMyTicket(): boolean {
    const hasAsgn = this.hasAssignee();
    if (!hasAsgn) return false;
    return (
      this.formattedTicket?.ticket?.assignee?.id === this.user?.id
    );
  }
  isReady(): boolean {
    const isReadyResult = this.formattedTicket?.ticket?.status
      ? Statuses.isReadyToViewStatus(
          this.formattedTicket?.ticket?.status,
        )
      : false;
    return isReadyResult;
  }
  isFailedToLoad(): boolean {
    if (!this.ticketError) return false;
    return this.ticketError
      .toLowerCase()
      .startsWith('failed to load ticket');
  }
  getAlertMessage(): string | undefined {
    if (this.isFailedToLoad()) {
      return `Failed to load ticket. Wait or click the button to go back to Workdesk`;
    } else if (!this.isReady()) {
      if (this.fromCE && this.CEInbox) {
        return `Ticket is being pre-processed. Wait or click the button to go back to Workdesk`;
      } else {
        return `Ticket is not ready`;
      }
    } else if (!this.hasAssignee()) {
      if (this.fromCE) {
        return `Ticket is unassigned. What would you like to do?`;
      } else {
        return;
      }
    } else if (!this.isMyTicket()) {
      const assigneeM = new Assignee(
        this.formattedTicket?.ticket?.assignee as EachAssigneesRes,
      );
      return `${assigneeM.displayName()} is working on the ticket. What would you like to do?`;
    }
    return;
  }
  getAlertButtonsInfo(): ButtonsInfo | undefined {
    const goToWorkDesk = {
      label: 'Go to workdesk',
      onClick: () => history.push('/workdesk'),
      autoFocus: true,
    };
    if (this.isFailedToLoad() || !this.isReady()) {
      return [goToWorkDesk];
    } else if (!this.hasAssignee()) {
      const isNonSi = this.isNonSi();
      return [
        { label: 'View ticket' },
        {
          // if ticket is non-si, have to mark si too before assign
          label: `${isNonSi ? 'Mark SI and ' : ''}Assign to me`,
          onClick: () => {
            if (!this.formattedTicket) return;
            if (isNonSi) {
              this.dispatch(
                assignUnassignActions.postAssignTicketWithAutoMarkSI(
                  this.formattedTicket?.id,
                ),
              );
            } else {
              this.dispatch(
                assignUnassignActions.postAssignTicket(
                  this.formattedTicket?.id,
                ),
              );
            }
          },
        },
        goToWorkDesk,
      ];
    } else if (!this.isMyTicket()) {
      return [{ label: 'View ticket' }, goToWorkDesk];
    }
    return;
  }

  getOnClose(): undefined | Function {
    if (this.isFailedToLoad()) {
      return () => {
        history.push('/workdesk');
      };
    } else if (!this.isReady()) {
      return () => {
        if (this.fromCE) {
          HistoryHelper.replaceQueryParamsWithoutReload();
        } else {
          history.push('/workdesk');
        }
      };
    } else {
      return () => {
        if (this.fromCE) {
          HistoryHelper.replaceQueryParamsWithoutReload();
        }
      };
    }
  }
  getAlertDetail():
    | { buttons: ButtonsInfo; message: string; onClose?: Function }
    | undefined {
    const message = this.getAlertMessage();
    if (!message) return;
    const buttons = this.getAlertButtonsInfo() as ButtonsInfo;
    return {
      message,
      buttons,
      onClose: this.getOnClose(),
    };
  }
}

export default MainPageAlert;
